export * from './Onboarding';

export const referralSourceOptions = [
  { label: 'AAPM Conference', value: 'AAPM Conference' },
  { label: 'Facebook', value: 'Facebook' },
  { label: 'LinkedIn', value: 'LinkedIn' },
  { label: 'Doximity', value: 'Doximity' },
  { label: 'Print Ad', value: 'Print Ad' },
  { label: 'Reddit', value: 'Reddit' },
  { label: 'Email', value: 'Email' },
  { label: 'Google', value: 'Google' },
  { label: 'Bing', value: 'Bing' },
  { label: 'Word of mouth', value: 'Word of mouth' },
  { label: 'Other', value: 'Other' },
];

export const celloReferralSourceOption = {
  label: 'Existing user',
  value: 'Cello',
};
